export default {
  title: 'My profile',
  tabs: {
    settings: 'My Settings',
    edit: 'Edit my profile',
    services: 'My services',
    company: 'My company',
    achievements: 'My achievements',
    security: 'Authentication and security',
    publicProfile: 'My public profile',
    myInfo: 'My informations',
  },
  firstName: 'First Name',
  firstNamePlaceholder: 'Enter your first name',
  lastName: 'Last Name',
  lastNamePlaceholder: 'Enter your last name',
  city: 'City',
  cityPlaceholder: 'Enter your city',
  postalCode: 'Postal Code',
  postalCodePlaceholder: 'Enter your postal code',
  phone: 'Phone',
  phonePlaceholder: 'Enter your phone number',
  languagesSpoken: 'Languages spoken',
  remoteWork: 'Do you work remotely',
  yes: 'Yes',
  professionalDescription: 'Describe your professional practice',
  professionalDescriptionPlaceholder:
    'Describe your professional experience, skills, and what makes you unique',
  professionalDescriptionNotice:
    "Personal contact details aren't allowed in profiles. Don't worry—they're shared automatically once you've connected on Pigeons!",
  charactersRemaining: 'characters remaining',
  servicesOffered: 'Services offered',
  newServicePlaceholder: 'New service',
  newDescriptionPlaceholder: 'Description (optional)',
  serviceNotFoundHint: "You didn't find your service? Write it down",
  servicesHint: 'Add another service',
  serviceAddedSuccess: 'New service added successfully!',
  serviceAddError: 'Error adding service. Please try again.',
  fieldRequired: 'This field is required.',
  profileUpdateError: 'Error updating profile. Please try again.',
  profileUpdateSuccess: 'Profile updated successfully!',
  saving: 'Saving...',
  achievements: {
    projectName: 'Project name',
    serviceOffered: 'Service offered',
    uploadImage: 'Upload an image',
    add: 'Add achievement',
    save: 'Save',
    imageFormatAllowed:
      'The allowed formats are .jpeg and .png. The display is in square format (1:1).',
    imageUploadHint: 'Click here to add an image',
    achievementUploadHint: 'Click here to add an achievement',
    maxFiles: 'You can upload a maximum of 5 files.',
    fileAdded: 'file added',
    currentImage: 'Current image',
    removeImage: 'Remove image',
  },
  security: {
    changePassword: 'Change my password',
    currentPassword: 'Your current password',
    newPassword: 'Your new password',
    twoFA: 'Two-factor authentication',
    activated: 'Activated',
    deactivated: 'Deactivated',
    phone: 'Your phone number',
    confirmPhone: 'Confirm your phone number',
  },
  save: 'Save',
  industryAddedSuccess: 'Industry added!',
  industryAddError: 'Could not add industry.',
  childQuoteOfferPending: 'Pending',
} as const;
